"use client"

import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"

import { cn } from "@/lib/utils"

function Tabs({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return (
    <TabsPrimitive.Root
      data-slot="tabs"
      className={cn("cy:flex cy:flex-col cy:gap-2", className)}
      {...props}
    />
  )
}

function TabsList({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        "cy:bg-muted cy:text-muted-foreground cy:inline-flex cy:h-9 cy:w-fit cy:items-center cy:justify-center cy:rounded-lg cy:p-[3px]",
        className
      )}
      {...props}
    />
  )
}

function TabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        "cy:data-[state=active]:bg-background cy:dark:data-[state=active]:text-foreground cy:focus-visible:border-ring cy:focus-visible:ring-ring/50 cy:focus-visible:outline-ring cy:dark:data-[state=active]:border-input cy:dark:data-[state=active]:bg-input/30 cy:text-foreground cy:dark:text-muted-foreground cy:inline-flex cy:h-[calc(100%-1px)] cy:flex-1 cy:items-center cy:justify-center cy:gap-1.5 cy:rounded-md cy:border cy:border-transparent cy:px-2 cy:py-1 cy:text-sm cy:font-medium cy:whitespace-nowrap cy:transition-[color,box-shadow] cy:focus-visible:ring-[3px] cy:focus-visible:outline-1 cy:disabled:pointer-events-none cy:disabled:opacity-50 cy:data-[state=active]:shadow-sm cy:[&_svg]:pointer-events-none cy:[&_svg]:shrink-0 cy:[&_svg:not([class*=size-])]:size-4",
        className
      )}
      {...props}
    />
  )
}

function TabsContent({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn("cy:flex-1 cy:outline-none", className)}
      {...props}
    />
  )
}

export { Tabs, TabsList, TabsTrigger, TabsContent }
